import { ReactNode } from 'react';
import { Drawer, Portal, CloseButton } from '@chakra-ui/react';
import ViewContent from './view-content';
import useDialogCleanup from '@/lib/hooks/use-dialog-cleanup';
import '@/styles/print.css';

interface Props {
  isOpen: boolean;
  onClose(): void;
  content: any;
  drawerId?: string;
  autoOpenPrintDialog?: boolean;
  footer?: ReactNode;
  // Anonymous viewers: hides favorite/share/manage actions and comments.
  isPublic?: boolean;
}

export default function ContentDrawer({
  isOpen,
  onClose,
  content,
  drawerId,
  autoOpenPrintDialog,
  footer,
  isPublic,
}: Props) {
  useDialogCleanup(isOpen);
  return (
    <Drawer.Root
      id={`view-content-drawer-${drawerId}`}
      size='xl'
      placement='end'
      lazyMount
      unmountOnExit
      open={isOpen}
      onOpenChange={(details) => {
        if (!details.open) onClose();
      }}
    >
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content bg='bg.panel' shadow='lg'>
            <Drawer.CloseTrigger asChild>
              <CloseButton
                size='sm'
                position='absolute'
                top={4}
                insetEnd={4}
                zIndex={2}
              />
            </Drawer.CloseTrigger>
            <Drawer.Body>
              <div data-print-target>
                {content && (
                  <ViewContent
                    data={content}
                    inDrawer
                    isPublic={isPublic}
                    onClose={onClose}
                    autoOpenPrintDialog={autoOpenPrintDialog}
                  />
                )}
              </div>
            </Drawer.Body>
            {footer && (
              <Drawer.Footer justifyContent='flex-start' borderTopWidth='1px' borderColor='border'>
                {footer}
              </Drawer.Footer>
            )}
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
}
